// `voice.clone`: a brand's voice cloned from a sound of a template run (spec G14-yapper, the
// voice lock), kept as one of the brand's own voices. A run's step alone starts it; live lists
// no such job, and a Studio draft never holds one.
import { VoiceCloneQuote, VoiceCloneRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"voice.clone"> = {
  type: "voice.clone",
  label: "Voice clone",
  source: "form",
  pair: "voice.clone",
  fields: () => ({}),
  request: VoiceCloneRequest,
  quote: VoiceCloneQuote,
};
